import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ScrollTrigger } from "@/lib/gsap";

export default function RouteScrollFix() {
    const { pathname } = useLocation();

    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
        const t = setTimeout(() => ScrollTrigger.refresh(), 80);
        return () => clearTimeout(t);
    }, [pathname]);

    return null;
}
